import { useParams } from 'react-router-dom';
import React, { useState } from 'react';
import {
  deleteSiteSupervisorQuery,
  fetchSiteSupervisorsQuery,
} from 'app/edozvola/cases/construction-participants/service/construction-participants.queries';
import { SiteSupervisorView } from 'app/edozvola/cases/construction-participants/model/construction-participants.model';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ViewTable from 'app/shared/view-table/view-table';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import { TABLE_QUERY_KEYS } from 'app/config/constants';
import { getInvalidRowsForTable } from 'app/shared/util/validation-errors.util';
import { getCaseContext } from 'app/shared/util/context-util';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';

const SiteSupervisorTable = ({ setSiteSupervisor, setReadOnly }) => {
  const { id } = useParams<{ id: string }>();
  const [idSiteSupervisorToDelete, setIdSiteSupervisorToDelete] = useState();
  const [deleteModalShown, setDeleteModalShown] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const invalidRowIds = getInvalidRowsForTable(TABLE_QUERY_KEYS.SITE_SUPERVISORS_TABLE);

  const { mutate: deleteSiteSupervisorMutation, isPending: siteSupervisorDeletionPending } = deleteSiteSupervisorQuery(id);

  const openDeleteDialog = idToDelete => {
    setIdSiteSupervisorToDelete(idToDelete);
    setDeleteModalShown(true);
  };

  const removeSiteSupervisor = () => {
    setDeleteModalShown(false);
    deleteSiteSupervisorMutation(idSiteSupervisorToDelete);
  };

  const openSiteSupervisorForm = (idSiteSupervisor: number, readOnly: boolean) => {
    setSiteSupervisor(idSiteSupervisor);
    setReadOnly(readOnly);
  };

  const renderTableRow = (value: SiteSupervisorView, siteSupervisorIndex: number, totalItems: number) => {
    return (
      <tr key={siteSupervisorIndex} className={invalidRowIds.includes(value.idSiteSupervisor) ? 'invalid-table-row' : ''}>
        <td>{value.authorizationNumber}</td>
        <td>{value.name}</td>
        <td>{value.oib}</td>
        <td>
          {value.siteSupervisorOfficeName}
          <br />
          {value.siteSupervisorOfficeAddress}
        </td>

        <td>
          <div className={'actions-container'}>
            {sidebarItemPair?.canView && (
              <TooltipWrapper message={'Pregledaj'}>
                <FontAwesomeIcon
                  icon={'eye'}
                  className={'icon-table'}
                  onClick={() => openSiteSupervisorForm(value.idSiteSupervisor, true)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canEdit && (
              <TooltipWrapper message={'Uredi'}>
                <FontAwesomeIcon
                  icon={'pen-to-square'}
                  className={'icon-table'}
                  onClick={() => openSiteSupervisorForm(value.idSiteSupervisor, false)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canDelete && (
              <TooltipWrapper message={'Obriši'}>
                <FontAwesomeIcon icon={'trash-alt'} className={'icon-table'} onClick={() => openDeleteDialog(value.idSiteSupervisor)} />
              </TooltipWrapper>
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ViewTable
        renderTableRow={renderTableRow}
        noDataMessage={'Nema nadzornih inženjera'}
        initialPaginationColumn={'idSiteSupervisor'}
        fetchDataQuery={fetchSiteSupervisorsQuery}
        fetchDataProps={id}
      >
        <ViewTableHeaderColumn renderSort sortKey={'authorizationNumber'} columnLabels={['Broj ovlaštenja']} width={'5%'} />
        <ViewTableHeaderColumn renderSort sortKey={'name'} columnLabels={['Ime i prezime']} width={'15%'} />
        <ViewTableHeaderColumn renderSort sortKey={'oib'} columnLabels={['OIB']} width={'5%'} />
        <ViewTableHeaderColumn renderSort sortKey={'siteSupervisorOfficeName'} columnLabels={['Ured nadzornog inženjera']} width={'15%'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Akcije']} width={'3%'} />
      </ViewTable>
      <Modal scrollable isOpen={deleteModalShown} size={'lg'} toggle={() => setDeleteModalShown(false)} centered>
        <ModalHeader>
          <span>Brisanje nadzornog inženjera</span>
        </ModalHeader>
        <ModalBody>
          <div>Jeste li sigurni da želite obrisati podatke?</div>
        </ModalBody>
        <ModalFooter>
          <Button size={'lg'} label="Odustani" outline onClick={() => setDeleteModalShown(false)} />
          <Button size={'lg'} label="Obriši" color={'danger'} onClick={removeSiteSupervisor} />
        </ModalFooter>
      </Modal>
    </>
  );
};

export default SiteSupervisorTable;
